import { findAuthenticationError, findForbiddenError } from './utils';
import { logError } from '../utils/logError';
import { UserLoadState } from '../stores/UserStore/types';
import type { ErrorResponse } from '@apollo/client/link/error';
import type { IStore } from '../stores/Store';

const onGraphqlError = (error: ErrorResponse, store: IStore): void => {
  const authError = findAuthenticationError(error.graphQLErrors);

  if (authError) {
    logError(
      {
        errorCode: 'CHECK_AUTHENTICATION_GQL_UNAUTHENTICATED_ERROR',
        description: 'cm-graphql: Authentication error',
      },
      {
        authError,
      },
    );
    store?.userStore?.setUserLoadState(UserLoadState.UNAUTHENTICATED);
  }

  const forbiddenError = findForbiddenError(error.graphQLErrors);
  if (forbiddenError) {
    logError(
      {
        errorCode: 'CHECK_FORBIDDEN_GQL_FORBIDDEN_ERROR',
        description: 'cm-graphql: Forbidden error',
      },
      {
        forbiddenError,
      },
    );
    store?.userStore?.setUserLoadState(UserLoadState.FORBIDDEN);
  }
};

export default onGraphqlError;
